<template>
    <v-container>
    <h2>Excel werkjaar</h2>
    <v-btn color="green">
        <downloadexcel :fetch= "fetchDataJaar">
            Download
        </downloadexcel>
    </v-btn>
    <br>
    <h2>Excel kamp</h2>
    <v-btn color="green">
    <downloadexcel :fetch= "fetchDataKamp">
        Download
    </downloadexcel>
    </v-btn>
    <br>
    <h2>Full database</h2>
    <v-btn color="green">
    <downloadexcel :fetch = "fetchAllData">
        Download
    </downloadexcel>
    </v-btn>
    </v-container>
</template>
 
<script>
import downloadexcel from "vue-json-excel";
import db from '@/firebase/initdb'
 
export default {
  name: "App",
  components: {
    downloadexcel,
  },
  data(){
    return {
        //data
    }
  }, 
  methods:{
    async fetchDataJaar(){
        return await fetchData('ingeschrevenJaren')
    },
    async fetchDataKamp(){
        return await fetchData('ingeschrevenKampen')
    },
    async fetchAllData(){
        let ref = db.collection('leden');
        const snapshot = await ref.get();
        let leden = [];
        snapshot.forEach(doc => {
            leden.push(flatten(doc.data()));
        });
        return leden;
    }
  }
};

async function getWerkjaar(){
    const snapshot = await db.collection('extra').doc('extra').get();
    return snapshot.data().werkjaar;
}

async function fetchData(key){
    const huidigWerkjaar = await getWerkjaar();
    let ref = db.collection('leden').where(key, 'array-contains', huidigWerkjaar);
    const snapshot = await ref.get();
    let leden = [];
    snapshot.forEach(doc => {
        leden.push(flatten(doc.data()));
    });
    return leden;
}

function flatten(input, prevKey = ""){
  let output = {};
  for(var key in input){
    let newkey = prevKey === "" ? key : prevKey + '_' + key;
    if(input[key] instanceof Object){
      output = {...output, ...flatten(input[key], newkey)};  
    }
    else{
      output[newkey] = input[key];
    }
  }
  return output;
}

</script>